var _circle, _mask, _rect, _mask2, _rect2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnterprises(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EAF9F7"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "enterprises_svg__path-2-inside-1",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 20,
    width: 8,
    height: 14,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 20,
    width: 8,
    height: 14,
    rx: 1,
    stroke: "#5DB39D",
    strokeWidth: 4,
    mask: "url(#enterprises_svg__path-2-inside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "enterprises_svg__path-3-inside-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 12,
    height: 20,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 12,
    height: 20,
    rx: 1,
    stroke: "#5DB39D",
    strokeWidth: 4,
    mask: "url(#enterprises_svg__path-3-inside-2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 33h20M20 18h4M20 22h4M20 26h4",
    stroke: "#5DB39D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNFQUY5RjciLz4KPG1hc2sgaWQ9InBhdGgtMi1pbnNpZGUtMSIgZmlsbD0id2hpdGUiPgo8cmVjdCB4PSIyNiIgeT0iMjAiIHdpZHRoPSI4IiBoZWlnaHQ9IjE0IiByeD0iMSIvPgo8L21hc2s+CjxyZWN0IHg9IjI2IiB5PSIyMCIgd2lkdGg9IjgiIGhlaWdodD0iMTQiIHJ4PSIxIiBzdHJva2U9IiM1REIzOUQiIHN0cm9rZS13aWR0aD0iNCIgbWFzaz0idXJsKCNwYXRoLTItaW5zaWRlLTEpIi8+CjxtYXNrIGlkPSJwYXRoLTMtaW5zaWRlLTIiIGZpbGw9IndoaXRlIj4KPHJlY3QgeD0iMTYiIHk9IjE0IiB3aWR0aD0iMTIiIGhlaWdodD0iMjAiIHJ4PSIxIi8+CjwvbWFzaz4KPHJlY3QgeD0iMTYiIHk9IjE0IiB3aWR0aD0iMTIiIGhlaWdodD0iMjAiIHJ4PSIxIiBzdHJva2U9IiM1REIzOUQiIHN0cm9rZS13aWR0aD0iNCIgbWFzaz0idXJsKCNwYXRoLTMtaW5zaWRlLTIpIi8+CjxwYXRoIGQ9Ik0xNCAzM0gzNCIgc3Ryb2tlPSIjNURCMzlEIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjAgMThIMjQiIHN0cm9rZT0iIzVEQjM5RCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTIwIDIySDI0IiBzdHJva2U9IiM1REIzOUQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMCAyNkgyNCIgc3Ryb2tlPSIjNURCMzlEIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgEnterprises as ReactComponent };